import Vue from 'vue';
import da from "element-ui/src/locale/lang/da";

const filters = {
    parseTodoType(data) {
        switch (data) {
            case 0:
                return '全部事项';
            default:
                return '其他'
        }
    },
    parseNum(data) {
        if(!data && data !==0) return '0';
        return data.toLocaleString('hanidec', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    //电价保留3位小数
    parseElecNum(data) {
      if(!data && data !==0) return '0';
      return data.toLocaleString('hanidec', {minimumFractionDigits: 3})
    },
    parseMoney(data) {
        if(!data) return '￥0.00';
        return data.toLocaleString('zh-Hans-CN', { style: 'currency', currency: 'CNY' })
    },
    parseTime(data) {
        // if(data === 0) return '1分钟';
        if(!data) return '----';
        let day = ~~(data / (3600 * 24));
        let hour = ~~((data % (3600 * 24)) / 3600);
        let min = ~~((data % (3600)) / 60);
        let sec = ~~(data % 60);
        if(day!==0){
            return `${day}天${hour}小时`
        }
        if(hour>0){
            return `${hour}小时${min}分`
        }
        if(min>0){
            return `${min}分${sec}秒`
        }
        return  `${sec}秒`
    },
    parseAllTime(data) {
        if(!data) return '----';
        let day = ~~(data / (3600 * 24));
        let hour = ~~((data % (3600 * 24)) / 3600);
        let min = ~~((data % (3600)) / 60);
        let sec = ~~(data % 60);
        if(day!==0){
            return `${day}天${hour}小时${min}分${sec}秒`
        }
        if(hour>0){
            return `${hour}小时${min}分${sec}秒`
        }
        if(min>0){
            return `${min}分${sec}秒`
        }
        return  `${sec}秒`
    }
};

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
